import { render, staticRenderFns } from "./comp5.vue?vue&type=template&id=78a9266c"
import script from "./comp5.vue?vue&type=script&lang=js"
export * from "./comp5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports